import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/catch';
import {Injectable} from '@angular/core';
import {ApiEndpoints} from '../ApiEndpoints';
import {ApiUtils} from '../ApiUtils';
import 'rxjs/add/operator/map';
import { plainToClass } from 'class-transformer';
import { SharedMethods } from '../../../../util/sharedMethods-service';
import { Commentaire } from '../../model/commentaire';



@Injectable()
export class CommentService {


  iSconnecting: boolean = false;

  comments: Commentaire[]

  constructor(public apiEndpoints: ApiEndpoints, public http: HttpClient,
              public apiUtils: ApiUtils,
              // public networkService:NetworkService,
              // public sharedMethods: SharedMethods
              public sharedMethods: SharedMethods,
              ) { }

  getComments() {
    this.iSconnecting = true;
    return new Promise<Commentaire[]>(resolve => {
      this.http.get(this.apiEndpoints.URL_GET_COMMENT,
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        .subscribe((data: Commentaire[]) => {
            const comments = plainToClass(Commentaire, data);
            this.comments = comments;
            resolve(comments);
            this.iSconnecting = false;
          },
          err => {
            // console.log(err);
            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            this.iSconnecting = false;
        });
    });
  }

  save(comment: Commentaire) {

      const dev = {
          /* firebaseToken: device.firebase_token,
          browser: device.browser,
          browserVersion: device.browser_version,
          os: device.os,
          osVersion: device.os_version,
          type: device.type,
          lang: device.lang,
          countryCode: device.country_code,
          countryName: device.country_name,
          latitude: device.latitude,
          longitude: device.longitude,
          city: device.city,
          ipv4: device.ipv4, */
          // name: comment.name,
      };
      

      return new Promise<Commentaire>(resolve => {
        this.http.patch(this.apiEndpoints.GET_URL_PATCH_COMMENT(comment.id), dev,
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe((data: Commentaire) => {
              /* resolve(data);
              this.iSsaving = false; */
              resolve(data);
            },
            err => {
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              // alert(JSON.stringify(err));
              //this.iSsaving = false;
            });
      });


  }

  deleteComment(comment: Commentaire) {

    this.iSconnecting = true;
  
    return new Promise(resolve => {
      this.http.delete(this.apiEndpoints.GET_URL_DELETE_COMMENT(comment.id),
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        .subscribe(data => {

            resolve(data);
            this.iSconnecting = false;

          },
          err => {
            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            // alert(JSON.stringify(err));
            this.iSconnecting = false;
        });
    });

  }

}
